import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../styles/ui.css';

export default function MyRequests() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const token = localStorage.getItem('token');

  useEffect(() => {
    const run = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/children/MyRequests`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setRows(data.children || []);
      } catch (e) {
        setError('Failed to load requests');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [API_BASE_URL, token]);

  const pillForStatus = (status) => {
    const s = (status || '').toLowerCase();
    if (s.includes('approved')) return <span className="child-status approved">{status}</span>;
    if (s.includes('rejected') || s.includes('resubmit'))
      return <span className="child-status rejected">{status}</span>;
    if (s.includes('pending') || s.includes('under review') || s.includes('submitted'))
      return <span className="document-status pending">{status}</span>;
    return <span className="child-status submitted">{status}</span>;
  };

  if (loading) {
    return (
      <div className="proposal-details-container">
        <div className="card">
          <div className="empty-state">Loading…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="proposal-details-container">
      <div className="card">
        <div className="details-header">
          <h2>My Extension &amp; Amendment Requests</h2>
          <span className="status-pill-header">{rows.length} item(s)</span>
        </div>

        {error && <div className="error-text" style={{ marginTop: 8 }}>{error}</div>}

        {rows.length === 0 ? (
          <div className="empty-state" style={{ marginTop: 8 }}>No requests yet.</div>
        ) : (
          <div className="card" style={{ marginTop: 12 }}>
            <table className="table-std">
              <thead>
                <tr>
                  <th style={{ width: 220 }}>Parent Proposal</th>
                  <th>Title</th>
                  <th style={{ width: 130 }}>Type</th>
                  <th style={{ width: 180 }}>Status</th>
                  <th style={{ width: 170 }}>Created</th>
                  <th style={{ width: 100 }} />
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.child_id}>
                    <td>{r.custom_id || r.proposal_id}</td>
                    <td style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 360
                    }}>
                      {r.title}
                    </td>
                    <td>{r.kind}</td>
                    <td>{pillForStatus(r.status)}</td>
                    <td>{new Date(r.created_at).toLocaleString()}</td>
                    <td>
                      <button className="btn primary" onClick={() => navigate(`/children/${r.child_id}`)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
